import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["columnSelector", "conditionList", "consequenceList", "diagramContainer"]
  static values = {
    teamId: String,
    taxId: String,
    initialConditions: Array,
    initialConsequences: Array
  }

  connect() {
    this.conditions = [...(this.initialConditionsValue || [])]
    this.consequences = [...(this.initialConsequencesValue || [])]
    this.renderLists()
    this.initSelect2()
    this.initDiagramListener()
  }

  initDiagramListener() {
    window.addEventListener("message", (event) => {
      if (event.data.type === "fieldSelected") {
        const { xpath, role } = event.data
        if (role === "S") {
          this.addColumn(xpath, this.conditions)
        } else if (role === "E") {
          this.addColumn(xpath, this.consequences)
        }
        this.renderLists()
        this.updateDiagramHighlights()
      }
    })
  }

  addColumn(value, list) {
    if (value && !list.includes(value)) {
      list.push(value)
    }
  }

  updateDiagramHighlights() {
    const iframe = this.diagramContainerTarget.querySelector('iframe')
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({
        type: "updateHighlights",
        conditions: this.conditions,
        consequences: this.consequences
      }, "*")
    }
  }

  initSelect2() {
    // Wait for jQuery and Select2 to load from CDN
    const checkSelect2 = setInterval(() => {
      if (window.jQuery && window.jQuery.fn.select2) {
        clearInterval(checkSelect2)
        const $ = window.jQuery
        $(this.columnSelectorTarget).select2({
          width: '100%',
          placeholder: 'Selecione uma coluna...'
        })
      }
    }, 100)
  }

  addCondition() {
    const $ = window.jQuery
    if (!$) return
    const value = $(this.columnSelectorTarget).val()
    if (value && !this.conditions.includes(value)) {
      this.conditions.push(value)
      this.renderLists()
      $(this.columnSelectorTarget).val('').trigger('change')
    }
  }

  addConsequence() {
    const $ = window.jQuery
    if (!$) return
    const value = $(this.columnSelectorTarget).val()
    if (value && !this.consequences.includes(value)) {
      this.consequences.push(value)
      this.renderLists()
      $(this.columnSelectorTarget).val('').trigger('change')
    }
  }

  removeCondition(event) {
    const value = event.currentTarget.dataset.value
    this.conditions = this.conditions.filter(c => c !== value)
    this.renderLists()
    this.updateDiagramHighlights()
  }

  removeConsequence(event) {
    const value = event.currentTarget.dataset.value
    this.consequences = this.consequences.filter(c => c !== value)
    this.renderLists()
    this.updateDiagramHighlights()
  }

  renderLists() {
    this.conditionListTarget.innerHTML = this.conditions.map(c => this.itemTemplate(c, 'removeCondition')).join('')
    this.consequenceListTarget.innerHTML = this.consequences.map(c => this.itemTemplate(c, 'removeConsequence')).join('')
  }

  itemTemplate(value, action) {
    return `
      <li class="flex items-center justify-between py-2 px-3 bg-white rounded shadow-sm border border-gray-200 hover:bg-gray-50">
        <span class="text-sm font-medium text-gray-700">${value}</span>
        <button type="button" data-action="click->rules-config#${action}" data-value="${value}" title="Remover" class="text-red-600 hover:text-red-900 p-1 focus:outline-none">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
        </button>
      </li>
    `
  }

  async save() {
    const response = await post(`/account/teams/${this.teamIdValue}/rules/save_tax_columns`, {
      body: JSON.stringify({
        tax_id: this.taxIdValue,
        condition_columns: this.conditions,
        consequence_columns: this.consequences
      })
    })

    if (response.ok) {
      window.location.href = `/account/teams/${this.teamIdValue}/rules/grid?tax_id=${this.taxIdValue}`
    } else {
      alert("Erro ao salvar colunas.")
    }
  }
}
